import Regex from '../regex';
import ColorsList from '../colorsList';
import { hexToRgb, rgbString2Array, rgbaString2Array, generateBullets } from '../javascript';

const styleByTag = {
  STRONG: 'bold',
  EM: 'italic',
  U: 'underLined',
};

let NBSP_REGEX = /&(nbsp);/g;

export async function shortMsgTextToJson(domNode) {   
  const channelValue = getShortMessageData(domNode);
  return channelValue;
}

const getShortMessageData = node =>
 {
  let result = {};
  let tagValue = [];
  node.length > 0 &&
    node.forEach(data => {
      let defaultStyles = {
        bold: false,
        italic: false,
        underLined: false,
        backgroundColor: [0, 0, 0, 0],
        color: [0, 0, 0],
      };
      let editorData = {};
      if (data?.nodeName === '#text') {
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else if (data.childNodes.length === 1 && (data.childNodes[0].nodeName !== "STRONG" && data.childNodes[0].nodeName !== "EM")) {
        editorData = getSingleEditorData(data, defaultStyles);
        if(data.nodeName === 'P'){
          editorData.textValue = `${editorData.textValue}\n`
        }
        tagValue.push(editorData);
      } else if (data.className === 'mention') { 
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else if (data.childNodes.length === 1 && (data.childNodes[0].nodeName === "STRONG" || data.childNodes[0].nodeName === "EM") && data.nodeName === 'A') { 
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else {
        let customStyles = getColorAndInlineStyle(data);
        let parentStyles = { ...defaultStyles, ...customStyles };
        let tagStyle = styleByTag[data.nodeName];
        if (tagStyle) {
          parentStyles[tagStyle] = true;
        }
        for (let a = 0 ; a < data.childNodes.length; a++) {
          let el = data.childNodes[a];
            // if(el.nodeName === "#text") {
              parentStyles = {
                ...parentStyles,
                bold: false,
                italic: false,
                underLined: false,
                backgroundColor: [0, 0, 0, 0],
                color: [0, 0, 0],
              };
            // }
            if (el.nodeName === "STRONG" || el.nodeName === "EM") {
            let tagStyle = styleByTag[el.nodeName];
            if (tagStyle) {
              parentStyles[tagStyle] = true;
            }
            tagValue = tagValue.concat(
              Array.from(el.childNodes).map(node => {
                editorData = getSingleEditorData(node, parentStyles)
                if(a === data.childNodes.length - 1){
                  editorData.textValue = `${editorData.textValue}\n`
                }
                return editorData;
              }),
            );
          } else {
            editorData = getSingleEditorData(el, parentStyles);
            if(data.nodeName === 'P' && a === data.childNodes.length - 1){
              editorData.textValue = `${editorData.textValue}\n`
            }
            tagValue.push(editorData);
          }
        }
      }
    });
  result = tagValue;
  return result;
};


const getBlockData = (element, isDownload, referencedList) => {
  const dataType = element.getAttribute('data-element-type');
  const svgHtml = element.childNodes && element.childNodes[0]?.innerHTML;
  let result = {};
  let elementType = 'text';
  if (['<?xml', '<svg'].some(data => svgHtml?.startsWith(data))) elementType = 'svg';
  if (
    dataType === 'table' ||
    dataType === 'referenced' ||
    dataType === 'dynamic-table' ||
    dataType === 'textBox' ||
    dataType === 'checkboxGroup' ||
    dataType === 'checkBox' || 
    dataType === 'radiobuttongroup' || 
    dataType === 'radiobutton' || 
    dataType === 'signature' ||
    dataType === 'combobox'

  )
    elementType = dataType;
  switch (elementType) {
    case 'text':
      result = getTextData(element, isDownload);
      break;
    case 'svg':
      result = getSvgData(element, svgHtml);
      break;
    case 'table':
      result = getTableData(element, isDownload);
      break;
    case 'textBox':
      let textResult = getTextData(element, isDownload);
      result = getFillableElement(element, textResult);
      break;
    case 'referenced' :
      let tagStyles = element && element.style.cssText;
      const styles = getComputedStyle(element);
      if (tagStyles) {
        tagStyles = stylesToJson(tagStyles);
      }
      tagStyles = { ...tagStyles, width: parseFloat(styles.width), height: parseFloat(styles.height) };
      result.tagValue = element.childNodes[0].dataset.referenceId;
      result.tagName = 'referenced';
      result.thumbnail = element.childNodes[0].dataset.thumbnail;
      result.tagStyles = tagStyles;
      if (referencedList) {
        const referencedElement = referencedList.filter(el => `${el.uuid}` === element.dataset.uuid);
        if (referencedElement.length === 1) {
          result.jsonText = referencedElement[0].elementDetails.jsonText;
        }
      }
      break;
    case 'dynamic-table':
      result = getDynamicTableData(element, isDownload, referencedList);
      break;
    case 'checkboxGroup':
      result = getCheckBoxGroupData(element, isDownload, referencedList);
      break;
    case 'checkBox':
      result = getCheckBoxData(element, isDownload, referencedList);
      break;
    case 'radiobuttongroup':
      result = getCheckBoxGroupData(element, isDownload, referencedList, true);
      break;
    case 'radiobutton':
      result = getCheckBoxData(element, isDownload, referencedList, true);
      break;
    case 'signature':
      result = getSignatureData(element);
      break;
    case 'combobox':
      result = getComboBoxData(element, isDownload, referencedList);
      break;
    default:
      break;
  }

  return result;
};

const getTextData = (element, isDownload) => {
  let result = {};
  let editor = element.getElementsByClassName('ql-editor');
  editor = editor && editor[0];
  if (editor && editor.childNodes) {
    let tagStyles = element.style && element.style.cssText;
    if (tagStyles) tagStyles = stylesToJson(tagStyles);
    if (editor.childNodes.length === 1) {
      if (['UL', 'OL'].includes(editor.childNodes[0].tagName)) {
        const listData = getListData(editor.childNodes[0], tagStyles);
        listData.listDetails['tagStyles'] = tagStyles;
        result = listData.listDetails;
      } else {
        result = getSingleELementData(editor.childNodes[0], tagStyles);
      }
    } else {
      let blockElements = [];
      let height = 0;
      let bulletHeight = tagStyles.translateY;
      editor.childNodes.forEach(elem => {
        if (['UL', 'OL'].includes(elem.tagName)) {
          let listStyles = { ...tagStyles, translateY: bulletHeight };
          const listData = getListData(elem, listStyles);
          bulletHeight += listData.height;
          height += listData.height;
          blockElements.push(listData.listDetails);
        } else {
          let data = getSingleELementData(elem);
          let translateY = height + tagStyles.translateY;
          height += data.tagStyles.height;
          bulletHeight += data.tagStyles.height;
          let transformStyles = {
            rotate: tagStyles.rotate,
            translateX: tagStyles.translateX,
            translateY,
          };
          data.tagStyles = { ...data.tagStyles, ...transformStyles };
          blockElements.push(data);
        }
      });
      result = { tagName: 'block', tagStyles, blockElements };
    }
  }
  return result;
};

const getFillableElement = (element, textRes) => {
  let result = {};
  const formField = {
    fieldName: element.getAttribute('data-inputbox-fieldName'),
    formElementType: "textbox",
    scroll: element.getAttribute('data-inputbox-enablescroll') === "true" || Boolean(false),
    multiline: element.getAttribute('data-inputbox-enablescroll') === "true" || Boolean(false),
    passwordField: element.getAttribute('data-inputbox-showpassword') === "true"|| Boolean(false),
    required: element.getAttribute('data-inputbox-isRequired') === "true" || Boolean(false),
    readOnly: element.getAttribute('data-inputbox-isReadOnly') === "true" || Boolean(false),
    isVariable: element.getAttribute('data-inputbox-isvariable') === "true" || Boolean(false),
    maxLength: element.getAttribute('data-inputbox-maxlength') ? parseInt(element.getAttribute('data-inputbox-maxlength')) : 100
  };
  let editor = element.getElementsByClassName('ql-editor');
  editor = editor && editor[0];
  if (editor && editor.childNodes) {
    let tagStyles = element.style && element.style.cssText;
    if (tagStyles) tagStyles = stylesToJson(tagStyles);
    tagStyles.borderColor = rgbString2Array(getComputedStyle(element).outlineColor);
    let result;
    console.log({ textRes: JSON.parse(JSON.stringify(textRes)) });
    if (editor.childNodes.length === 1) {
      textRes.tagStyles.borderColor = tagStyles.borderColor;
    } else {
      if (textRes.blockElements) {
        var data = [];
        let dataLength = textRes?.blockElements?.length;
        for (var p in textRes.blockElements) {
          data = [...data, ...textRes.blockElements[p].text];
        }
        textRes.text = data;
        textRes.tagName = "paragraph";
        textRes.tagStyles = {
          ...textRes.blockElements[0].tagStyles,
          width: textRes.tagStyles.width,
          height: textRes.tagStyles.height,
          translateX: textRes.tagStyles.translateX,
          translateY: textRes.tagStyles.translateY,
          backgroundColor: textRes.tagStyles.backgroundColor,
          borderColor: tagStyles.borderColor
        };
        delete textRes.blockElements;
      }
    }
    const samplePara = document.createElement('p');
    textRes.text = textRes.text.map(el => {
      samplePara.innerHTML = el.textValue;
      return Object.assign({}, el, {textValue: samplePara.innerHTML.replaceAll(NBSP_REGEX, ' ')});
    });
    delete tagStyles.border;
    delete tagStyles['border-color'];
    delete tagStyles.outline;
    result = {
      tagName: "textbox",
      ...result,
      tagStyles,
      formField: {
        ...formField,
        placeHolder: {
          ...textRes,
        }
      },
    };
    return result;
  }
  return result;
};

const getComboBoxData = (element, isDownload, referencedList) => {
  const tagName = 'combobox';
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  if(tagStyles?.border){
    let borderColor = tagStyles.border.replace('1px solid', '');
    tagStyles = { ...tagStyles, borderWidth: 1, borderColor: borderColor ? rgbString2Array(borderColor) : 'rgb(204,204,204)' };
  }
  const dataAttributes = { ...element.dataset };
  const formField = {
    formElementType: 'combobox',
    fieldName: dataAttributes.fieldname,
    isVariable: Number(dataAttributes.isvariable) === 1,
  };
  if (parseInt(dataAttributes.isvariable) === 1) {
    let dynamicVariableDetails = {
      isVariable: true,
      variableId: dataAttributes?.variableid,
      name: dataAttributes?.variablename,
      maxLength: dataAttributes?.maxlength,
    };
      formField.variableId = parseInt(dataAttributes.variableid);
      formField.dynamicLabelStyles = tagStyles;
      formField.dynamicLabelValue = {
        variableId: parseInt(dataAttributes.variableid),
        name: dataAttributes.variablename
      }
      formField.formElementStyles = {
        tagName: "combobox",
        tagStyles: tagStyles
      }
   } else {
    let comboboxElements = [];
    let comboValuesNodes = element?.getElementsByClassName('comBox-values')[0]?.childNodes;
    let selectedVal = element?.getElementsByClassName('ant-select-selection-selected-value')[0]?.innerText;
    if (comboValuesNodes?.length > 0) {
      for (var i = 0; i < comboValuesNodes?.length; i++) {
        let comboData;
        comboData = {
          text: [
            {
              backgroundColor: tagStyles.backgroundColor,
              underLined: false,
              color: tagStyles.color,
              size: tagStyles.size,
              textValue: comboValuesNodes[i].innerText,
              variableDetails: {
                isVariable: false,
              },
              letterSpacing: 0,
              bold: false,
              family: tagStyles.family,
              italic: false,
            },
          ],
          tagName: 'paragraph',
          formField: {
            fieldName: dataAttributes.fieldname,
            formElementType: 'combobox',
            isVariable: false,
            readOnly: false,
            checked: selectedVal === comboValuesNodes[i]?.innerText,
          },
          tagStyles: tagStyles,
        };
        comboboxElements.push(comboData);
      }
    }
    formField.formElementDetails = comboboxElements;
  }
  return {
    tagName,
    tagStyles,
    formField,
  };
};

const getSignatureData = (element) => {
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  tagStyles.borderColor = rgbString2Array(getComputedStyle(element).outlineColor);
  return {
    tagName: 'signature',
    tagStyles,
    formField: {
      fieldName: element.getAttribute('data-field-name'),
      formElementType: 'signature'
    }
  }
}

const splitBulletParagraph = (data, element, tagName = 'OL') => {
  const { bullet, tagStyles } = data;
  let result = [];
  let bulletData = JSON.parse(JSON.stringify(data));
  let paragraphData = JSON.parse(JSON.stringify(data));
  let bulletValue = bullet.bulletValue;
  const listElStyles = getComputedStyle(element);
  const styles = getComputedStyle(element, ':before');
  if (tagName === 'UL') {
    bulletValue = '\u2022';
  }

  let textMargin = parseFloat(listElStyles.marginLeft.replaceAll('px', ''));
  const newEl = document.createElement('span');
  newEl.style.fontFamily = styles.fontFamily;
  newEl.style.fontSize = styles.fontSize;
  newEl.style.lineHeight = styles.lineHeight;
  newEl.innerText = bullet.bulletValue;
  document.body.appendChild(newEl);
  const actualWidth = newEl.getBoundingClientRect().width;
  document.body.removeChild(newEl);
  let bulletStyles = {
    backgroundColor: rgbString2Array(styles.backgroundColor),
    color: rgbString2Array(styles.color),
    height: parseFloat(styles.height),
    lineSpacing: tagStyles.lineSpacing,
    translateX: tagStyles.translateX + textMargin - (parseFloat(styles.width) / 2) - parseFloat(styles.marginRight.replaceAll('px', '')) - (actualWidth / 2),
    width: actualWidth,
    size: parseFloat(styles.fontSize),
  };
  const quotesExist = styles.fontFamily.startsWith('"') && styles.fontFamily.endsWith('"');
  const family = quotesExist
    ? styles.fontFamily.replace(Regex.DOUBLE_QUOTES, '')
    : styles.fontFamily;

  let bulletText = {
    backgroundColor: rgbString2Array(styles.backgroundColor),
    color: rgbString2Array(styles.color),
    bold: false,
    family,
    italic: false,
    size: parseFloat(styles.fontSize),
    textValue: bulletValue,
    underLined: false,
  };
  bulletData.tagStyles = { ...bulletData.tagStyles, ...bulletStyles };
  bulletData.text = [bulletText];
  paragraphData.tagStyles['translateX'] += textMargin;
  paragraphData = { ...paragraphData, bullet: { isBullet: false, indent: bullet.indent } };
  result.push(bulletData);
  result.push(paragraphData);
  return result;
};

const getListData = (element, tagStyles = {}) => {
  const { tagName } = element;
  let preIndent = 0;
  let content = {};
  if (element?.childNodes?.length > 0) {
    let listStyles = element.style && element.style.cssText;
    if (listStyles)
      listStyles = stylesToJson(listStyles);
    else listStyles = {};
    listStyles = { ...tagStyles, listStyles };
    let blockElements = [];
    let height = 0;
    for (const list of element.childNodes) {
      // styles
      let allListStyles = getComputedStyle(list);
      let translateY = height + tagStyles.translateY;
      height += parseFloat(allListStyles.height);
      let transformStyles = {
        rotate: tagStyles.rotate,
        translateX: tagStyles.translateX,
        translateY,
      };
      // list details
      let data = getSingleELementData(list);
      let listType = getListDetails(list);
      const { indent, bulletType } = listType;
      let bullet = {
        isBullet: true,
        indent,
        bulletType,
      };
      if (content[`list-${indent}`]) {
        content[`list-${indent}`]['count'] += 1;
        bullet['bulletValue'] = generateBullets(content[`list-${indent}`]);
        if (indent < preIndent) {
          for (let index = indent + 1; index <= preIndent; index++) {
            if (content[`list-${index}`]) {
              content[`list-${index}`]['count'] = -1;
            }
          }
        }
      } else {
        content[`list-${indent}`] = { bulletType, count: 0 };
        bullet['bulletValue'] = generateBullets(content[`list-${indent}`]);
      }
      preIndent = indent;
      data['bullet'] = bullet;
      data.tagStyles = { ...data.tagStyles, ...transformStyles };
      let splittedData = splitBulletParagraph(data, list, tagName);
      blockElements.push(...splittedData);
    }

    let listDetails = {
      tagName: getTagNames(element.tagName),
      tagStyles: listStyles,
      blockElements,
      list: {
        isList: true,
        listType: element.tagName === 'OL' ? 'numbered list' : 'bulleted list', // numbered list / bulleted list
      },
    };
    const result = { height, listDetails };
    return result;
  }
};

const getListDetails = element => {
  let indent = 0,
    bulletType = '';
  let className = element.getAttribute('class');
  if (className) {
    indent = parseInt(className.split('-').pop()) || 0;
  }
  const styles = getComputedStyle(element, ':before');
  const content = styles.getPropertyValue('content');
  if (content === 'none' || content === '') {
    return;
  }
  let contentType = content && content.split(Regex.STRING_BETWEEN_COMMA_AND_BRACKET);
  if (contentType.length === 1) {
    bulletType = element.parentNode.nodeName === 'OL' ? 'decimal' : 'dot';
  } else {
    bulletType = contentType[1].trim();
  }
  let list = {
    indent,
    bulletType,
  };
  return list;
};

const getSvgData = (element, tagValue) => {
  const tagName = 'svg';
  let tagStyles = element.parentNode && element.parentNode.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  const result = { tagName, tagStyles, tagValue };
  return result;
};

const getTableData = (element, isDownload) => {
  const tagName = 'Table';
  const tagValue = '';
  let tableElements = [];
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  let rowValues = [];
  let tableRows = element.querySelectorAll('tr');
  let height = 0;
  tableRows &&
    tableRows.forEach(row => {
      const rowStyles = getComputedStyle(row);
      let currentRow = [];
      let width = 0;
      row &&
        row.childNodes &&
        row.childNodes.forEach(colData => {
          let childStyles;
          let lineSpacing = 0;
          let padding = 0;
          let editor = element.getElementsByClassName('ql-editor');
          if (editor && editor[0].childNodes[0]) {
            lineSpacing = getLineSpacing(editor[0]);
            childStyles = getComputedStyle(editor[0].childNodes[0]);
            padding = parseFloat(childStyles.padding);
          }
          let colStyles = getComputedStyle(colData);
          let {
            borderRightWidth = 0,
            backgroundColor,
            verticalAlign,
            textAlign,
            borderLeftColor,
          } = colStyles;
          borderRightWidth = parseFloat(borderRightWidth);
          padding = parseFloat(padding);
          let rowObj = colData && getTextData(colData, isDownload);
          backgroundColor = rgbString2Array(backgroundColor);
          const borderColor = borderLeftColor && rgbString2Array(borderLeftColor);
          let customStyles = {
            lineSpacing,
            columnWidth: parseFloat(colStyles.width),
            columnHeigth: parseFloat(rowStyles.height),
            borderWidth: borderRightWidth,
            cellPadding: padding,
            backgroundColor,
            borderColor,
            verticalAlignment: verticalAlign,
            horizontalAlignment: rowObj.tagStyles.alignment || textAlign,
            height: parseFloat(childStyles.height),
            width: parseFloat(childStyles.width),
            translateX: width + tagStyles.translateX,
            translateY: height + tagStyles.translateY,
            rotate: tagStyles.rotate,
          };
          rowObj.tagStyles = { ...rowObj.tagStyles, ...customStyles };
          currentRow.push(rowObj);
          width += parseFloat(colStyles.width);
        });
      rowValues.push(currentRow);
      height += parseFloat(rowStyles.height);
    });
  let tableObj = {
    tagStyles,
    rowValues,
  };
  tableElements.push(tableObj);
  const result = { tagName, tagValue, tableElements };
  return result;
};

const getCheckBoxGroupData = (element, isDownload, referencedList, isRadioButton = false) => {
  const tagName = isRadioButton ? 'radiobuttongroup' : 'checkboxgroup';
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  const dataAttributes = { ...element.dataset };
  const uuid = dataAttributes.uuid;
  const isEditing = dataAttributes.isEditing;
  const formField = {
    formElementType: isRadioButton ? 'radiobutton' : 'checkbox',
    fieldName: dataAttributes.fieldName,
    isVariable: Number(dataAttributes.isVariable) === 1,
    readOnly: Number(dataAttributes.readOnly) === 1,
    checkType: dataAttributes.checkType,
    direction: dataAttributes.checkboxDirection,
  };
  if (parseInt(dataAttributes.isVariable) === 1) { // TODO : Take dynamic styles and variable
    let checkBoxStyle = undefined;
    const blockElements = Array.from(element.querySelectorAll('.block-selectable')).map(blElement => {
      const blockElement = getBlockData(blElement, isDownload, referencedList);
      blockElement.tagStyles.translateX += tagStyles.translateX;
      blockElement.tagStyles.translateY += tagStyles.translateY;
      formField.variableId = parseInt(dataAttributes.checkboxVariableid);
      blockElement.formField = {
        ...blockElement.formField,
        ...formField
      };
      if((blockElement.tagName === "checkbox" || blockElement.tagName === "radiobutton" ) && checkBoxStyle === undefined){
        checkBoxStyle = blockElement.tagStyles;
      }
      else if((blockElement.tagName === "paragraph" || blockElement.tagName === "text") && formField.dynamicLabelStyles === undefined){
        formField.dynamicLabelStyles = blockElement.tagStyles;
      }
      formField.spacing = 10;
      formField.dynamicLabelValue = {
        variableId: parseInt(dataAttributes.labelVariableid),
        name: dataAttributes.labelVarname
      }
      formField.formElementStyles = {
        tagName: isRadioButton ? "radiobutton" : "checkBox",
        tagStyles: checkBoxStyle
      }
      return blockElement;
    });
  } else {
      const blockElements = Array.from(element.querySelectorAll('.block-selectable')).map(blElement => {
        const blockElement = getBlockData(blElement, isDownload, referencedList);
        blockElement.tagStyles.translateX += tagStyles.translateX;
        blockElement.tagStyles.translateY += tagStyles.translateY;
        blockElement.formField = {
          ...formField,
          ...blockElement.formField
        };
        return blockElement;
      });
      formField.formElementDetails = blockElements;
  }
  return {
    tagName,
    tagStyles,
    formField
  }
}

const getCheckBoxData = (element, isDownload, referencedList, isRadioButton) => {
  const tagName = isRadioButton ? 'radiobutton' : 'checkbox';
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  tagStyles = { ...tagStyles, borderColor: rgbString2Array(tagStyles['border-color']) };
  if (isRadioButton) {
    const radioButtonEl = element.querySelector('.ant-radio-inner');
    if (radioButtonEl) {
      tagStyles.backgroundColor = rgbaString2Array(getComputedStyle(radioButtonEl).background);
    }
  }
  const dataAttributes = { ...element.childNodes[0].dataset };
  const uuid = dataAttributes.uuid;
  const formField = {
    formElementType: isRadioButton ? 'radiobutton' : 'checkbox'
  };
  if (dataAttributes.isVariable === "true") { 
    formField.isVariable = dataAttributes.isVariable === "true";
    formField.fieldName = dataAttributes.fieldName;
  } else {
    formField.checked = isRadioButton ? element.querySelector('.ant-radio-input').checked 
    : element.querySelector('.ant-checkbox-input').checked;
  }
  return {
    tagName,
    tagStyles,
    formField
  }
}

const getDynamicTableData = (element, isDownload, referencedList) => {
  const tagName = 'table';
  let tagStyles = element.style && element.style.cssText;
  if (tagStyles) tagStyles = stylesToJson(tagStyles);
  const dataAttributes = { ...element.childNodes[0].dataset };
  const tableUUID = dataAttributes.uuid;
  delete dataAttributes.uuid;
  delete dataAttributes.elementType;
  delete dataAttributes.moveable;
  const table = {
    dynamic: true,
    enableHeader: dataAttributes.enableHeader === ("true"),
    enableTitle: dataAttributes.enableTitle === ("true"),
    showTitleOnPageBreak: dataAttributes.showTitleOnPageBreak === ("true"),
    showHeaderOnPageBreak: dataAttributes.showHeaderOnPageBreak === ("true"),
    variableName: dataAttributes.variableName,
    overflowStartY: parseInt(dataAttributes.overflowStartY, 10),
    pageBreakEndY: tagStyles.translateY + tagStyles.height,
  };
  delete tagStyles.height;
  if (table.enableTitle) {
    const titleEl = element.querySelector(`#title-${tableUUID}`);
    table.tableTitle = getBlockData(titleEl, isDownload, referencedList);
  }
  let rowStyles = [];
  const tableSchema = element.querySelector('#table-block');
  const tableHeader = Array.from(tableSchema.childNodes).map((resizableDiv, headerIndex) => {
    const columnNode = resizableDiv.childNodes[1].childNodes[0].childNodes[0];
    let header = {
      tableHeaderConfig: Object.assign({}, {
         keyToMap: resizableDiv.dataset.keyToMap,
         type: resizableDiv.dataset.type,
         format: resizableDiv.dataset.dateFormat
       })
    };
      const headerEl = getBlockData(columnNode, isDownload, referencedList);
      const customTableCell = resizableDiv.childNodes[1];
      let colStyles = getComputedStyle(customTableCell);
      let {
        borderLeftWidth = 0,
        backgroundColor,
        verticalAlign,
        borderLeftColor,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
      } = colStyles;
      borderLeftWidth = parseFloat(borderLeftWidth);
      let padding = [paddingTop.replace('px', ''), paddingRight.replace('px', ''), paddingBottom.replace('px', ''), paddingLeft.replace('px', '')];
      padding = padding.map(val => parseInt(val));
      backgroundColor = rgbString2Array(backgroundColor);
      const borderColor = borderLeftColor && rgbString2Array(borderLeftColor);
      let customStyles = {
          width: resizableDiv.clientWidth,
          columnWidth: resizableDiv.clientWidth,
          columnHeight: headerEl.tagStyles.height,
          borderWidth: borderLeftWidth,
          cellPadding: padding,
          backgroundColor,
          borderColor,
          verticalAlignment: verticalAlign,
      };
      headerEl.tagStyles = { ...headerEl.tagStyles, ...customStyles };
      if (!table.enableHeader) {
        headerEl.text[0] = Object.assign({}, headerEl.text[0], {
          size: 16,
          textValue : `Column-${headerIndex + 1}`
        });
      }
      header = Object.assign({}, header, headerEl);
    // }
    const rowIndex = table.enableHeader ? 2 : 1;
    // Row formatting
      const customTableRowCell = resizableDiv.childNodes[rowIndex].children[0];
      if (headerIndex === 0) {
        Array.from(resizableDiv.childNodes[rowIndex].children).forEach((cell, cellIndex) => {
          let newRowStyle = JSON.parse(cell.dataset.rowStyle);
          newRowStyle = {
             ...newRowStyle,
             backgroundColor: rgbaString2Array(newRowStyle.backgroundColor),
             color: rgbaString2Array(newRowStyle.color),
             borderColor: newRowStyle.borderWidth ? rgbaString2Array(newRowStyle.borderColor) : [0, 0, 0],
             cellPadding: newRowStyle.cellPadding.replaceAll("px", '').split(' ').map(val => parseInt(val))
          };
          delete newRowStyle.lineHeight;
          const existing = rowStyles.find(styles => JSON.stringify(styles) === JSON.stringify(newRowStyle));
          if (existing === undefined) {
            rowStyles.push(newRowStyle);
          }
        })
      }
      console.log({ customTableRowCell, rowStyles });
      let cellStyles = getComputedStyle(customTableRowCell);
      const inlineStyles = getColorAndInlineStyle(customTableRowCell);
      let {
        borderLeftWidth : rowBorderLeftWidth,
        backgroundColor: rowBackgroundColor,
        verticalAlign: rowVerticalAlign,
        borderLeftColor: rowBorderLeftColor,
        paddingLeft: cellPaddingLeft,
        paddingRight: cellPaddingRight,
        paddingTop: cellPaddingTop,
        paddingBottom: cellPaddingBottom,
        color,
        lineHeight,
      } = cellStyles;
      let {
        size,
        family,
        alignment,
        letterSpacing
      } = inlineStyles;
      rowBorderLeftWidth = parseFloat(rowBorderLeftWidth);
      let rowPadding = [cellPaddingTop.replace('px', ''), cellPaddingRight.replace('px', ''), cellPaddingBottom.replace('px', ''), cellPaddingLeft.replace('px', '')];
      rowPadding = rowPadding.map(val => parseInt(val));
      rowBackgroundColor = rgbString2Array(rowBackgroundColor);
      rowBorderLeftColor = rowBorderLeftColor && rgbString2Array(rowBorderLeftColor);
      color = color && rgbString2Array(color);
      let cellFormat = {
         borderWidth: rowBorderLeftWidth,
         cellPadding: rowPadding,
         backgroundColor: rowBackgroundColor,
         borderColor: rowBorderLeftColor,
         color,
         size,
         family,
         alignment,
         lineSpacing: lineHeight && parseFloat(lineHeight) / 16,
         letterSpacing,
//         verticalAlignment: rowVerticalAlign,
      };
    header.tableHeaderConfig = Object.assign({}, header.tableHeaderConfig, { cellFormat });
    return header;
  });
  table.tableHeader = tableHeader;
  table.rowStyles = rowStyles;

  const result = { tagName, table, tagStyles };
  return result;
};

const getSingleELementData = (node, overrideTagStyles = {}) => {
  let listType = getListDetails(node);
  let result = {};
  let styles = getBoundingRect(node);
  let allStyles = getComputedStyle(node);
  const backgroundColor = rgbString2Array(allStyles.backgroundColor);
  styles = {
    ...styles,
    backgroundColor,
    color: [0, 0, 0],
    alignment: allStyles.textAlign,
    lineSpacing: allStyles.lineHeight && parseFloat(allStyles.lineHeight) / 16,
  };
  const tagName = getTagNames(node.tagName);
  let parentStyles = node.style && node.style.cssText;
  if (parentStyles) {
    parentStyles = stylesToJson(parentStyles);
  }
  const obj = node.childNodes.length > 0 && getEditorData(node.childNodes);
  const tagStyles = { ...styles, ...obj.tagStyles, ...parentStyles, ...overrideTagStyles };
  result = {
    ...result,
    tagName,
    tagStyles,
    text:
      obj.tagValue.map(text => ({ ...text, family: tagStyles.family, size: tagStyles.size })) || '',
  };
  if (listType?.indent) {
    result['indent'] = listType.indent;
  }
  return result;
};

const getEditorData = node => {
  let result = {};
  let tagStyles = node[0].style?.cssText;
  if (tagStyles) {
    tagStyles = stylesToJson(tagStyles);
    result = { tagStyles };
  }
  let tagValue = [];
  node.length > 0 &&
    node.forEach(data => {
      let defaultStyles = {
        bold: false,
        italic: false,
        underLined: false,
        backgroundColor: [0, 0, 0, 0],
        color: [0, 0, 0],
      };
      let editorData = {};
      if (data?.nodeName === '#text') {
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else if (data.childNodes.length === 1 && (data.childNodes[0].nodeName !== "STRONG" && data.childNodes[0].nodeName !== "EM")) {
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else if (data.className === 'mention') { 
        editorData = getSingleEditorData(data, defaultStyles);
        tagValue.push(editorData);
      } else {
        let customStyles = getColorAndInlineStyle(data);
        let parentStyles = { ...defaultStyles, ...customStyles };
        let tagStyle = styleByTag[data.nodeName];
        if (tagStyle) {
          parentStyles[tagStyle] = true;
        }
        for (const el of data.childNodes) {
          if (el.nodeName === "STRONG" || el.nodeName === "EM") {
            let tagStyle = styleByTag[el.nodeName];
            if (tagStyle) {
              parentStyles[tagStyle] = true;
            }
            tagValue = tagValue.concat(Array.from(el.childNodes).map(node => getSingleEditorData(node, parentStyles)));
          } else {
            editorData = getSingleEditorData(el, parentStyles);
            tagValue.push(editorData);
          }
        }
      }
    });
  result = { ...result, tagValue };
  return result;
};

const getColorAndInlineStyle = element => {
  let allStyles = getComputedStyle(element);
  const tagStyles = {
    backgroundColor: rgbString2Array(allStyles.backgroundColor),
    color: rgbString2Array(allStyles.color),
    size: parseFloat(allStyles.fontSize),
  };
  let innerStyles = element.style?.cssText;
  if (innerStyles) {
    innerStyles = stylesToJson(innerStyles);
  }
  const styles = { ...tagStyles, ...innerStyles };
  return styles;
};

const getSingleEditorData = (element, styles) => {
  let mark = element.className === 'mention';
  let variableDetails = {
    isVariable: false,
    variableId: null,
    name: null,
    maxLength: null,
  };
  let objValue = styles;
  const styleNode = element.nodeName === '#text' ? element.parentNode : element;
  let customStyles = !mark ? getColorAndInlineStyle(styleNode) : {};
  objValue = { ...objValue, ...customStyles };
  objValue['textValue'] = element.textContent;
  if (element.nodeName === 'A') {
    const link = element.getAttribute('href');
    objValue = { ...objValue, link, underLined: true };
  }
  let tagDetails = element;
  while (tagDetails) {
    let tagStyle = styleByTag[tagDetails.nodeName];
    if (tagStyle) {
      objValue[tagStyle] = true;
    }

    if (tagDetails.className === 'mention') {
      const dataId = tagDetails.getAttribute('data-id');
      if (dataId) {
        variableDetails.isVariable = true;
        variableDetails.variableId = dataId;
        variableDetails.name = tagDetails.getAttribute('data-place-holder-text');
        variableDetails.maxLength = tagDetails.getAttribute('data-length');
        objValue['textValue']= `\${${tagDetails.getAttribute('data-place-holder-text')}}`;
      }
      const dateVarFormat = tagDetails.getAttribute('data-date-format');
      if(dateVarFormat){
        variableDetails.format = dateVarFormat;
      }
    }
    if (tagDetails.nodeName === '#text') {
      break;
    }
    tagDetails = tagDetails.childNodes[0];
  }
  objValue = { ...objValue, variableDetails };
  return objValue;
};

const getDocumentNode = element => {
  let parent = element;
  while (parent) {
    parent = parent.parentNode;
    const id = parent.getAttribute('id');
    if (id && id.startsWith('document-page')) {
      break;
    }
  }
  const position = parent.getBoundingClientRect();
  return position;
};

const getBoundingRect = element => {
  const parent = getDocumentNode(element);
  let position = element.getBoundingClientRect();
  let allStyles = getComputedStyle(element);
  const { height, width } = allStyles;
  const { x, y } = position;
  const styles = {
    height: parseFloat(height),
    width: parseFloat(width),
    translateX: x - parent.x - 1,
    translateY: y - parent.y - 1,
  };
  return styles;
};

export const stylesToJson = (styles, isPage = false) => {
  let objStyles = styles.split(';');
  objStyles.pop();
  let result = {};
  objStyles.forEach(data => {
    let split = data.split(':');
    let names = getStyles(split);
    result = { ...result, ...names };
  });
  if (isPage) {
    const { padding = 0 } = result;
    const stylesToOmit = ['top', 'right', 'bottom', 'left', 'margin', 'padding'];
    const pageStyles = {
      size: 'a4',
      dpi: 96,
      'right-margin': padding,
      'left-margin': padding,
      'top-margin': padding,
      'bottom-margin': padding,
    };
    stylesToOmit.forEach(data => delete result[data]);
    result = { ...result, ...pageStyles };
  }
  return result;
};

const getStyles = style => {
  let key = style[0].trim();
  let value = style[1].trim();
  let pair = {};
  let result = {};
  const styleName = {
    'font-weight': 'fontWeight',
    'font-size': 'size',
    'font-family': 'family',
    'text-align': 'alignment',
    'background-color': 'backgroundColor',
    background: 'backgroundColor',
    'line-height': 'lineSpacing',
    'letter-spacing': 'letterSpacing',
  };

  key = styleName[key] || key;
  switch (key) {
    case 'transform':
      const transform = getTransforms(value);
      result = { ...result, ...transform };
      break;

    case 'color':
    case 'backgroundColor':
      const color = getColors(value, key);
      result = { ...result, ...color };
      break;

    case 'height':
    case 'width':
    case 'top':
    case 'bottom':
    case 'left':
    case 'right':
    case 'size':
    case 'padding':
    case 'margin':
    case 'lineSpacing':
    case 'letterSpacing':
      value = parseFloat(value);
      pair = { [key]: value };
      result = { ...result, ...pair };
      break;
    case 'family':
      const quotesExist = value.startsWith('"') && value.endsWith('"');
      value = quotesExist ? value.replace(Regex.DOUBLE_QUOTES, '') : value;
      pair = { [key]: value };
      result = { ...result, ...pair };
      break;
    case 'box-shadow':
    case 'box-sizing':
    case 'transition':
    case 'overflow':
    case 'position':
      break;
    case 'fontWeight':
      pair = { bold: true };
      result = { ...result, ...pair };
      break;
    default:
      pair = { [key]: value };
      result = { ...result, ...pair };
      break;
  }
  return result;
};

const getTransforms = transform => {
  transform = transform.split(' ');
  let result = {};
  transform.forEach(data => {
    let key = data.split('(')[0];
    let value = data && data.match(Regex.STRING_BETWEEN_BRACKETS)[1];
    value = Number(value.replace(Regex.FLOAT, ''));
    let pair = { [key]: value };
    result = { ...result, ...pair };
  });
  return result;
};

const getColors = (colors, type) => {
  let colorCodes = colors;
  if (ColorsList[colors]) {
    colorCodes = hexToRgb(ColorsList[colors]);
  }
  if (colors === 'transparent') {
    let pair = { [type]: [0, 0, 0, 0] };
    return pair;
  }
  colorCodes = rgbString2Array(colorCodes);
  let pair = { [type]: colorCodes };
  return pair;
};

const getLineSpacing = node => {
  let lineSpacing = 0;
  if (node) {
    let editorStyle = getComputedStyle(node);
    lineSpacing = editorStyle?.lineHeight && parseFloat(editorStyle.lineHeight) / 16;
  }
  return lineSpacing;
};

const getTagNames = tag => {
  tag = tag.toLowerCase();
  let name = {};
  const tagName = {
    div: 'block',
    img: 'image',
    p: 'paragraph',
    ol: 'block',
    ul: 'block',
    li: 'paragraph',
  };
  name = tagName[tag] || tag;
  return name;
};
